import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { ServiceQuestionType } from '../api/create-question';
import {
  QUESTION_TYPE_LABELS,
  QUESTION_TYPE_VALUES,
} from '../utils/type-enum-mapper';

type QuestionTypeSelectProps = Omit<
  React.ComponentProps<typeof Select>,
  'value' | 'onValueChange'
> & {
  value: ServiceQuestionType;
  onValueChange: (value: ServiceQuestionType) => void;
};

export const QuestionTypeSelect = React.forwardRef<
  React.ElementRef<typeof Select>,
  QuestionTypeSelectProps
>(({ value, onValueChange, ...rest }, ref) => {
  return (
    <Select
      {...rest}
      onValueChange={(value) => onValueChange(value as ServiceQuestionType)}
      value={value as string}
    >
      <SelectTrigger ref={ref}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {QUESTION_TYPE_VALUES.map((type) => (
          <SelectItem key={type} value={type} className="capitalize">
            {QUESTION_TYPE_LABELS[type]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});
